export default __webpack_public_path__ + "static/media/8.cf1ad5c0.svg";